import { render, staticRenderFns } from "./cpmTransitionCard.vue?vue&type=template&id=5ffa5a94&scoped=true"
import script from "./cpmTransitionCard.vue?vue&type=script&lang=ts"
export * from "./cpmTransitionCard.vue?vue&type=script&lang=ts"
import style0 from "./cpmTransitionCard.vue?vue&type=style&index=0&id=5ffa5a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffa5a94",
  null
  
)

export default component.exports